import styled from "styled-components"

export const EspecialidadWrapper = styled.section`
  background-color: #fff;
`
